import React from 'react';
import { useEffect, useState } from 'react';
import './category2.css';
import blob from '../assets/blob2.png';
import Button from '../components/common/button';
import HeadingBlock from '../components/common/heading';
import { supabase } from '../supabase';

const CategoryCard2 = () => {
    const [categories, setCategories] = useState([]);

    useEffect(() => {
        const fetchCategories = async () => {
            const { data } = await supabase
                .from('categories')
                .select('*');

            setCategories(data || []);
        };
        fetchCategories();
    }, []);

    return (
        <>
            <section className="categoriesSection fixedWidth">
                <HeadingBlock
                        heading="Our Categories"
                        subheading="Explore vendors in each category."
                        style1="dark left decor headings1 padded2"
                    />
                <div className="catWrapper">
                    <div className="categoriesCont">
                    {categories
                        .filter((category) => ![7, 8].includes(category.id))
                        .slice(0, 6)
                        .map((category) => (
                        <div className="categoryCard2" key={category.id}>
                            <div className="catCard2ImgCont">
                                <img
                                    className="catImg moveIn2"
                                    src={category.image}
                                    alt={category.title}
                                />
                                <img className="catBlob scaleIn2" src={blob} alt="" />
                            </div>
                            <div className="cardBody">
                                <h1 className="light">{category.title}</h1>
                                <h6 className="light">{category.vendorsLength} Vendors</h6>
                                <Button cta="view vendors" style1="beige size1" link="/error" />
                            </div>
                        </div>
                    ))}
                </div>
                </div>
            </section>
        </>
    );
};

export default CategoryCard2;